import { Empty } from 'antd'
import { useMemo } from 'react'
import Chart from 'react-apexcharts'
import styles from '../../../../testrun.module.css'

const STATUS_COLORS = {
    Pending: '#faad14',
    Pass: '#52c41a',
    Fail: '#db2114',
    Retest: '#1890ff',
}

const ChartStatus = ({ data }) => {
    const statusSummary = Array.isArray(data?.statusSummary)
        ? data.statusSummary
        : []

    const labels = statusSummary.map((item) => item.status)
    const series = statusSummary.map((item) => Number(item.count ?? 0))
    const total = series.reduce((sum, count) => sum + count, 0)

    const options = useMemo(
        () => ({
            chart: {
                type: 'pie',
            },
            labels,
            colors: labels.map((label) => STATUS_COLORS[label] || '#d9d9d9'),
            legend: {
                position: 'bottom',
            },
            stroke: {
                show: false,
            },
            dataLabels: {
                enabled: total > 0,
                formatter(val, opts) {
                    const count = opts.w.config.series[opts.seriesIndex]
                    if (!Number.isFinite(val)) {
                        return `${count} (0%)`
                    }
                    return `${count} (${val.toFixed(0)}%)`
                },
            },
            plotOptions: {
                pie: {
                    dataLabels: {
                        offset: -20,
                        minAngleToShowLabel: 8,
                    },
                },
            },
            tooltip: {
                y: {
                    formatter: (val) => `${val} items`,
                },
            },
            noData: {
                text: 'No results recorded yet',
                align: 'center',
                verticalAlign: 'middle',
            },
        }),
        [labels, total]
    )

    if (!statusSummary.length) {
        return (
            <div className={styles.reportChartEmpty}>
                <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Status summary is not available for this report"
                />
            </div>
        )
    }

    if (total === 0) {
        return (
            <div className={styles.reportChartEmpty}>
                <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="No Pass / Fail / Pending / Retest results yet"
                />
            </div>
        )
    }

    return (
        <Chart
            options={options}
            series={series}
            type="pie"
            width="100%"
            height={300}
        />
    )
}

export default ChartStatus
